/**
 * Public site modules — visibility keys stored in website_settings as module_{id}_visible = '1'|'0'
 */
export const PUBLIC_MODULES = [
  {
    id: 'hero',
    settingKey: 'module_hero_visible',
    label: 'Hero banner',
    description: 'Top banner with couple names, date, and main buttons',
    group: 'sections',
  },
  {
    id: 'guest_message',
    settingKey: 'module_guest_message_visible',
    label: 'Message to guests',
    description: 'Welcome note below the hero (title + message)',
    group: 'sections',
  },
  {
    id: 'info_cards',
    settingKey: 'module_info_cards_visible',
    label: 'Gifting & dress code',
    description: 'Two info cards: Gifting with Love and Dress Code',
    group: 'sections',
  },
  {
    id: 'features',
    settingKey: 'module_features_visible',
    label: 'Plan your visit',
    description: 'Guest hub with cards for RSVP, program, venue, etc.',
    group: 'sections',
  },
  {
    id: 'love_story',
    settingKey: 'module_love_story_visible',
    label: 'Love story',
    description: 'Timeline section about your journey',
    group: 'sections',
  },
  {
    id: 'countdown',
    settingKey: 'module_countdown_visible',
    label: 'Countdown',
    description: 'Countdown timer to the wedding day',
    group: 'sections',
  },
  {
    id: 'rsvp',
    settingKey: 'module_rsvp_visible',
    label: 'RSVP',
    description: 'Guest RSVP form',
    group: 'guest',
    featureId: 'rsvp',
  },
  {
    id: 'program',
    settingKey: 'module_program_visible',
    label: 'Program',
    description: 'Wedding schedule by day',
    group: 'guest',
    featureId: 'program',
  },
  {
    id: 'venue',
    settingKey: 'module_venue_visible',
    label: 'Venue',
    description: 'Location, map, and directions',
    group: 'guest',
    featureId: 'venue',
  },
  {
    id: 'gifts',
    settingKey: 'module_gifts_visible',
    label: 'Gift registry',
    description: 'Wish list and gift reservations',
    group: 'guest',
    featureId: 'gifts',
  },
  {
    id: 'pledge',
    settingKey: 'module_pledge_visible',
    label: 'Pledge card',
    description: 'Cash pledge with downloadable card',
    group: 'guest',
    featureId: 'pledge',
  },
  {
    id: 'gallery',
    settingKey: 'module_gallery_visible',
    label: 'Gallery',
    description: 'Photo albums',
    group: 'guest',
    featureId: 'gallery',
  },
  {
    id: 'accommodation',
    settingKey: 'module_accommodation_visible',
    label: 'Places to stay',
    description: 'Recommended accommodation',
    group: 'guest',
    featureId: 'accommodation',
  },
  {
    id: 'travel_guide',
    settingKey: 'module_travel_guide_visible',
    label: 'Travel guide',
    description: 'Fly, bus, and self-drive guidance to Uganda',
    group: 'guest',
    featureId: 'travel_guide',
  },
];

export const MODULE_GROUPS = [
  { id: 'sections', title: 'Page sections' },
  { id: 'guest', title: 'Guest modules (cards, nav & footer)' },
];
